import "./PostItsOverlay.scss";
import { useState, forwardRef, useImperativeHandle } from "react";
import PostIts from "../../pages/PostIts/PostIts";

const PostItsOverlay = forwardRef(({ onOpenChange }, ref) => {
  const [isOpen, setIsOpen] = useState(false);

  const updateOpenState = (newState) => {
    const value = typeof newState === "function" ? newState(isOpen) : newState;
    setIsOpen(value);
    onOpenChange?.(value);
  };

  useImperativeHandle(ref, () => ({
    open: () => updateOpenState(true),
    close: () => updateOpenState(false),
    toggle: () => updateOpenState((prev) => !prev),
  }));

  if (!isOpen) return null;

  return (
    <div className="postits-overlay">
      <div
        className="postits-overlay-backdrop"
        onClick={() => updateOpenState(false)}
      />
      <div className="postits-overlay-content">
        <button
          className="postits-overlay-close"
          onClick={() => updateOpenState(false)}
          aria-label="Close Post-Its"
        >
          <span className="material-symbols-outlined">close</span>
        </button>
        <PostIts />
      </div>
    </div>
  );
});

PostItsOverlay.displayName = "PostItsOverlay";

export default PostItsOverlay;
